import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { z } from 'zod';

// TODO: consolidate to web util libs
export const usePathParams = <T>(schema: z.ZodType<T>) => {
  const params = useParams();
  return useMemo(() => schema.parse(params), [params, schema]);
};
